export function phaseLabel(phase) {
  return phase[0].toUpperCase() + phase.slice(1);
}

export function sliderValueForProgress(progress, max) {
  return String(Math.round(progress * Number(max)));
}

export class TimePanel {
  constructor(game) {
    this.game = game;
    this.toggle = null;
    this.panel = null;
    this.slider = null;
    this.label = null;
    this.play = null;
    this.pause = null;
  }

  init() {
    this.toggle = document.getElementById('toggle-time');
    this.panel = document.getElementById('time-of-day-panel');
    this.slider = document.getElementById('time-of-day');
    this.label = document.getElementById('time-of-day-label');
    this.play = document.getElementById('play-time');
    this.pause = document.getElementById('pause-time');

    const startScrub = () => { this.game._scrubbingTime = true; };
    const stopScrub = () => {
      if (!this.game._scrubbingTime) return;
      this.game._scrubbingTime = false;
      this.game._scheduleSave();
    };
    this.toggle.addEventListener('click', () => {
      const open = this.panel.hidden;
      this.panel.hidden = !open;
      this.toggle.setAttribute('aria-expanded', String(open));
      this.toggle.setAttribute('aria-pressed', String(open));
    });
    this.slider.addEventListener('pointerdown', startScrub);
    this.slider.addEventListener('pointerup', stopScrub);
    this.slider.addEventListener('pointercancel', stopScrub);
    this.slider.addEventListener('input', () => {
      this.game._scrubbingTime = true;
      this.game.clock.setProgress(Number(this.slider.value) / Number(this.slider.max));
      this.sync(true);
    });
    this.slider.addEventListener('change', stopScrub);
    this.play.addEventListener('click', () => {
      this.game.clock.paused = false;
      this.sync(true);
      this.game._scheduleSave();
    });
    this.pause.addEventListener('click', () => {
      this.game.clock.paused = true;
      this.sync(true);
      this.game._scheduleSave();
    });
    this.sync(true);
  }

  sync(force = false) {
    const { slider, label, play, pause } = this;
    if (!slider || !label || !play || !pause) return;
    const snapshot = this.game.clock.snapshot();
    const nextLabel = phaseLabel(snapshot.phase);
    if (force || label.textContent !== nextLabel) label.textContent = nextLabel;
    if (!this.game._scrubbingTime) {
      const value = sliderValueForProgress(snapshot.progress, slider.max);
      if (force || slider.value !== value) slider.value = value;
    }
    const playPressed = String(!snapshot.paused);
    const pausePressed = String(snapshot.paused);
    if (force || play.getAttribute('aria-pressed') !== playPressed) {
      play.setAttribute('aria-pressed', playPressed);
    }
    if (force || pause.getAttribute('aria-pressed') !== pausePressed) {
      pause.setAttribute('aria-pressed', pausePressed);
    }
  }
}
